/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';

prestashop.responsive = prestashop.responsive || {};

prestashop.responsive.current_width = window.innerWidth;
prestashop.responsive.min_width = 992;
prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;

function swapChildren(obj1, obj2) {
  var temp = obj2.children().detach();
  obj2.empty().append(obj1.children().detach());
  obj1.append(temp);
}

function toggleMobileStyles() {
  if (prestashop.responsive.mobile) {
    $("*[id^='_desktop_']").each(function (idx, el) {
      var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
      if (target.length) {
        swapChildren($(el), target);
      }
    });
    $('[data-collapse-hide-mobile]').collapse('hide');

  } else {
    $("*[id^='_mobile_']").each(function (idx, el) {
      var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
      if (target.length) {
        swapChildren($(el), target);
      }

    });
    $('[data-collapse-hide-mobile]').not('.show').collapse('show');
    $('[data-modal-hide-mobile].show').modal('hide');

  }

  prestashop.emit('responsive update', {
    mobile: prestashop.responsive.mobile
  });
}

function generate_menu_mobile() {
  if (prestashop.responsive.mobile) {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Gestion menu mobile
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // J'effectue des modifications après injection
    var main_menu_target= $('#main_menu > ul');

    $('#nav-mobile__body__rubrics').children().remove();
    main_menu_target.clone().attr('id', '').removeClass().children().unwrap().appendTo('#nav-mobile__body__rubrics');
    $('#nav-mobile__body__rubrics').find('.sub-menu').children().unwrap();
    $('#nav-mobile__body__rubrics').find('i:not(.-no-hide), svg:not(.-no-hide)').remove();

    // Gestion du fonctionnement du sous-menu
    $('.nav-mobile ul ul').wrap('<div class="nav-mobile__body__level"><div class="nav-mobile__body__level__container"></div></div>'); // Je construis mon menu mobile en injectant des divs

    // Gestion du traitement sur les sous-menus (liens retours, liens voir toute la gamme, icônes)
    $(".nav-mobile .nav-mobile__body__level").each(function () {
      // Je vérifie que le sous-menu a bien des enfants
      var level_has_children = $(this).find('> .nav-mobile__body__level__container > ul').children().length;
      if (level_has_children) {

        // Je stock les infos des liens pour les futurs traitements
        var level_siblings = $(this).siblings('a, span');
        var level_siblings__link = level_siblings.attr('href');
        var level_siblings__txt = level_siblings.text();

        // J'ajoute une icône dans le lien qui permet d'ouvrir le sous-menu (cela indique à l'utilisateur qu'il y a encore d'autres liens à découvrir)
        level_siblings.append(ukoo_icon_right);

		// J'ajoute un lien qui permet de voir toute la gamme (cela permet à l'utilisateur de tout de même accéder à une catégorie après ouverture de son sous-menu)
        if (level_siblings__link) {
          $("<li><a href=\"" + level_siblings__link + "\"><b>" + ukoo_txt_see_all_rubric + "</b></a></li>").prependTo($(this).find("> .nav-mobile__body__level__container > ul"));
      }

        // J'ajoute un lien qui permet le retour au sous-menu précédent
        $("<div class=\"nav-mobile__body__level__back\"><span>"+ukoo_icon_left+"<span>"  + level_siblings__txt + "</span></span></div>").prependTo($(this));
      }
    });

    // Gestion de l'ouverture des sous-menus
    $(".nav-mobile .nav-mobile__body__level").siblings('a, span').on("click", function (e) {
      var level_has_children = $(this).find('+ .nav-mobile__body__level > .nav-mobile__body__level__container > ul').children().length;
      // Je vérifie que le sous-menu que l'on s'apprête à ouvrir a bien des enfants
      if (level_has_children) {
        e.preventDefault(); // J'annule le clic original sur le lien (j'obfusque son href)
        $(this).parents('.nav-mobile__body__level').scrollTop(0); // Je fais remonter le scroll de son parent si il y a eu scroll (permet d'avoir un sous-menu toujours ouvert à sa position initiale)
        $(this).find("+ .nav-mobile__body__level").toggleClass("nav-mobile__body__level--open"); // J'ajoute une classe indiquant que le sous-menu est désormais ouvert
        $(this).parent().closest(".nav-mobile__body__level").css("overflow", "hidden"); // J'empêche le scroll vertical de tous les sous-menus précédent (évite le quadruple scroll)
      }
    });

    // Gestion du retour à sous-menu précédent
    $('.nav-mobile__body__level__back').click(function(e){
      e.preventDefault(); // J'annule le clic original sur le lien (j'obfusque son href)
      // Je retire la classe permettant d'ouvrir le sous-menu actuel / Je rend possible le scroll vertical (précédent empêché)
      $(this).parent(".nav-mobile__body__level").removeClass("nav-mobile__body__level--open").parent().closest('.nav-mobile__body__level').css('overflow-y','scroll'); // parent().closest est obligatoire car closest prend également en compte l'élément courant
    });

    // Ouverture et fermeture de la navigation mobile
    $("#nav-mobile__opener").on("click", function (e) {
      e.preventDefault();
      $("body").addClass("body__nav-mobile--is-open");
      $('.nav-mobile').attr('aria-expanded',true);

    });
    $("#nav-mobile__closer").on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("body__nav-mobile--is-open");
      $('.nav-mobile').attr('aria-expanded',false);
    });
  }
  prestashop.emit('responsive update', {
    mobile: prestashop.responsive.mobile
  });
}

$(window).on('resize', function () {
  var _cw = prestashop.responsive.current_width;
  var _mw = prestashop.responsive.min_width;
  var _w = window.innerWidth;
  var _toggle = (_cw >= _mw && _w < _mw) || (_cw < _mw && _w >= _mw);
  prestashop.responsive.current_width = _w;
  prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;
  if (_toggle) {
    toggleMobileStyles();
    generate_menu_mobile();
  }
});

$(document).ready(function () {
  if (prestashop.responsive.mobile) {
    toggleMobileStyles();
    generate_menu_mobile();
  }

});
